export enum ConsumptionClassId {
    CAT1 = "CAT1",
    CAT2 = "CAT2",
    P011 = "P011",
    P012 = "P012",
}
